import type { WCardTranslations } from "./pl";

export const en: WCardTranslations = {
  triggerAriaLabel: "Your shopping cart",
  drawerTitle: "Your shopping cart",
  drawerClose: "Close",
  countLabel: "Quantity",
  countDecrement: "Decrease quantity",
  countIncrement: "Increase quantity",
  deleteItem: "Remove item from cart",
  variantColorAlt: "Variant colour swatch",
  priceBeforePromotion: "Price before promotion",
  emptyState: "Your shopping cart is empty.",
  toPay: "To pay",
  continueShopping: "Continue shopping",
  pay: "Order",
  updateFailed: "Could not update the cart.",
  deleteFailed: "Could not remove the item from the cart.",
  updating: "Updating cart…",
  formatPrice: (value: number, currency: string): string => {
    const rounded = (Math.round(value * 100) / 100).toFixed(2);
    return currency ? `${rounded} ${currency}` : rounded;
  },
};
